var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('canvas',{ref:"chartbpm",staticClass:"is-margin-b-20",attrs:{"height":"200px","width":"1000px"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }